<template>
  <div>
    <div class="card mb-5">
      <div class="card-body">
        <h1 class="mb-0">Create List</h1>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="form-group">
          <label for="new_list_name_input">List Name</label>
          <input
            name="new_list_name_input"
            type="text"
            class="form-control"
            ref="new_list_name_input"
            v-model="new_list.name"
            v-on:keyup.enter="createList"
          >
          <ul id="content-type-list" class="nav nav-pills nav-pills-primary nav-pills-icons my-3 d-flex justify-content-center">
            <li class="nav-item">
              <a class="nav-link" @click.prevent="new_list.content_type = 'default'" :class="{'active': new_list.content_type === 'default'}" data-toggle="tab" href="#">
                <i class="ion ion-md-cube"></i> Anything
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" @click.prevent="new_list.content_type = 'movie'" :class="{'active': new_list.content_type === 'movie'}" data-toggle="tab" href="#">
                <i class="ion ion-md-videocam"></i> Movies
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" @click.prevent="new_list.content_type = 'tvshow'" :class="{'active': new_list.content_type === 'tvshow'}" data-toggle="tab" href="#">
                <i class="ion ion-md-tv"></i> TV Shows
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" @click.prevent="new_list.content_type = 'book'" :class="{'active': new_list.content_type === 'book'}" data-toggle="tab" href="#">
                <i class="ion ion-md-book"></i> Books
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" @click.prevent="new_list.content_type = 'game'" :class="{'active': new_list.content_type === 'game'}" data-toggle="tab" href="#">
                <i class="ion ion-logo-game-controller-b"></i> Video Games
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" @click.prevent="new_list.content_type = 'boardgame'" :class="{'active': new_list.content_type === 'boardgame'}" data-toggle="tab" href="#">
                <i class="fa fa-chess-pawn"></i> Board Games
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" @click.prevent="new_list.content_type = 'place'" :class="{'active': new_list.content_type === 'place'}" data-toggle="tab" href="#">
                <i class="ion ion-md-pin"></i> Places
              </a>
            </li>
          </ul>
          <div>
            <label for="">Options</label>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" checked="" v-model="new_list.public">
                <span class="form-check-sign"></span>
                Public List: anyone can view, but only you can edit
              </label>
            </div>
          </div>
          <div>
            <button class="btn btn-success w-100" @click.prevent="createList">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import constants from '@/constants'

export default {

  name: 'CreateList',

  data () {
    return {
      new_list: {
        name: '',
        content_type: 'default',
        public: true,
      },
      content_type_icons: constants.content_type_icons,
      content_type_names: constants.content_type_names,
    }
  },

  computed: {
    user () {
      return this.$store.state.users.profile
    },
  },

  methods: {
    createList () {
      this.$store.dispatch('lists/createList', this.new_list)
      this.clearAddListForm()
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  margin-bottom: 10px;
  .card-header {
    padding: 15px;
  }
}
.card {
  .form-group {
    text-align: initial;
    .form-check {
      .form-check-label {
        font-size: 14px;
      }
    }
    label {
      font-size: 1.0rem;
      margin-bottom: .5rem;
    }
  }
}
#content-type-list .nav-item {
  display: flex;
  max-width: 135px;
  @media screen and (max-width: 768px) {
    max-width: none;
    display: block;
    width: 50%;
    .nav-link {
      padding: 11px 11px;
      i {
        display: inline-block;
        font-size: 20px;
        line-height: 30px;
        vertical-align: middle;
        margin-right: 3px;
      }
    }
  }
}
</style>
